import axios from "@/api/axiosInstance";

export const deactivateEmployee = async (
  employeeUuid: string,
): Promise<void> => {
  await axios.delete(`/api/private/employees/${employeeUuid}`);
};
